import { translate } from '../../libs/translateService';

export default translate;
